module.exports = __webpack_public_path__ + "img/thumb-jordan-off.37439a0a.jpg";